// React
import { Container, Row, Col, Image } from "react-bootstrap";
import { motion } from "framer-motion";

// Hooks
import { useTranslation } from "../../hooks/useTranslation";

/* images */
import imgPilates from "../../assets/images/services/pilates.jpg";
import imgCircuit from "../../assets/images/services/circuit.jpg";
import imgTrx from "../../assets/images/services/trx.jpg";
import imgBodyshape from "../../assets/images/services/bodyshape.jpg";
import imgStretch from "../../assets/images/services/pilates.jpg";
import imgFunctional from "../../assets/images/services/functional.jpg";
import imgPersonal from "../../assets/images/services/personal.jpg";

export default function ServicesList() {
    const t = useTranslation();

    const services = [
        { img: imgPilates, key: "pilates" },
        { img: imgCircuit, key: "koredzes" },
        { img: imgTrx, key: "trx" },
        { img: imgBodyshape, key: "alakformalo" },
        { img: imgStretch, key: "mobilitas" },
        { img: imgFunctional, key: "funkcionalis" },
        { img: imgPersonal, key: "szemelyiedzes" },
    ];

    /* motion helpers */
    const fadeUp = i => ({
        hidden: { opacity: 0, y: 40 },
        show: { opacity: 1, y: 0, transition: { delay: i * .05, duration: .4 } }
    });

    return (
        <>
            {services.map(({ img, key }, i) => {
                const reverse = i % 2 ? "flex-md-row-reverse" : "";
                const bgStripe = i % 2 ? "stripeLight" : "stripeDark";

                return (
                    <div id={key} key={key} className={`serviceStripe ${bgStripe}`}>
                        <Container fluid className="stripeContainer">
                            <Row className={`innerRow ${reverse}`}
                                as={motion.div}
                                variants={fadeUp(i)}
                                initial="hidden"
                                whileInView="show"
                                viewport={{ once: true, margin: "-50px" }}
                            >

                                {/* image pane */}
                                <Col md={12} xxl={6} className="imgCol d-flex px-4">
                                    <motion.div className="glassPane imgPane m-auto"
                                        whileHover={{ scale: 1.04 }}
                                        transition={{ duration: 0.35, ease: "easeInOut" }}
                                    >
                                        <Image src={img} alt={t(`services.${key}.name`)}
                                            className="stripeImg" fluid
                                            width={800}          // real pixel dimensions
                                            height={850}
                                        />
                                    </motion.div>
                                </Col>

                                {/* text pane */}
                                <Col md={12} xxl={6} className="txtCol d-flex px-4">
                                    <motion.div className="glassPane txtPane m-auto"
                                        whileHover={{ scale: 1.04 }}
                                        transition={{ duration: 0.35, ease: "easeInOut" }}
                                    >
                                        <h3 className="stripeName">{t(`services.${key}.name`)}</h3>
                                        <p className="stripeDesc">{t(`services.${key}.desc`)}</p>
                                    </motion.div>
                                </Col>

                            </Row>
                        </Container>
                    </div>
                );
            })}
        </>
    );
}
